import { Field } from '@chakra-ui/react';
import { useState } from 'react';

/**
 * Input Component
 * Wrapper around native HTML input with Chakra Field
 * Note: Using native input for better compatibility with Chakra v3
 */
export function Input({
  label,
  error,
  helperText,
  leftElement,
  rightElement,
  isRequired,
  isDisabled,
  isReadOnly,
  onFocus,
  onBlur,
  ref,
  ...props
}) {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <Field.Root invalid={ !!error } required={ isRequired } disabled={ isDisabled } readOnly={ isReadOnly }>
        {label && <Field.Label>{ label }</Field.Label>}
        <input
          ref={ ref }
          disabled={ isDisabled }
          readOnly={ isReadOnly }
          style={{
            width: '100%',
            height: '36px',
            padding: '0 0.75rem',
            borderRadius: '3px',
            border: '1px solid',
            borderColor: error ? '#DE350B' : (isFocused ? '#4C9AFF' : '#DFE1E6'),
            backgroundColor: isFocused ? '#FFFFFF' : '#FAFBFC',
            color: '#172B4D',
            fontSize: '14px',
            lineHeight: '1.5',
            outline: 'none',
            transition: 'border-color 0.1s, background-color 0.1s',
          }}
          onFocusCapture={(e) => {
            setIsFocused(true);
            if (onFocus) onFocus(e);
          }}
          onBlurCapture={(e) => {
            setIsFocused(false);
            if (onBlur) onBlur(e);
          }}
          { ...props }
        />
        {error && <Field.ErrorText>{ error }</Field.ErrorText>}
        {helperText && !error && <Field.HelperText>{ helperText }</Field.HelperText>}
      </Field.Root>
    )
}

export default Input
